import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-down",
  templateUrl: "./med-icon-arrow-down.component.html",
})
export class MedIconArrowDownComponent extends SvgMixinComponent {}
